import React from "react";
import { answerText } from "../../lib/initialAssessmentAdmin";

/** A participant's answers, section by section, as the team and the trainer read them. */
export default function Answers({ questionnaire, answers }) {
  if (!answers) return null;
  return (
    <div className="mt-2 grid gap-3">
      {(questionnaire?.sections || []).map((section) => (
        <div key={section.key}>
          <div className="text-xs font-semibold uppercase tracking-widest text-[#6B7280]">{section.title}</div>
          <dl className="mt-1 grid gap-1.5 text-sm">
            {section.questions.map((q) => (q.type === "grid" ? (
              <div key={q.id}>
                <dt className="text-[11px] text-[#6B7280]">{q.label}</dt>
                <dd>
                  <ul className="grid gap-0.5">
                    {q.rows.map((row) => (
                      <li key={row.key} className="flex items-baseline justify-between gap-3 text-[#373A45]">
                        <span>{row.label}</span>
                        <span className="shrink-0 tabular-nums">{answers[q.id]?.[row.key] ?? "—"} din {q.max}</span>
                      </li>
                    ))}
                  </ul>
                </dd>
              </div>
            ) : (
              <div key={q.id}>
                <dt className="text-[11px] text-[#6B7280]">{q.label}</dt>
                <dd className="whitespace-pre-line text-[#373A45]">{answerText(q, answers) || "—"}</dd>
              </div>
            )))}
          </dl>
        </div>
      ))}
    </div>
  );
}
